import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const addDaprButtonStyles = makeStyles<Theme>((theme: Theme) => ({
  disabled: {
    color: theme.palette.grey[500]
  }
}));
